// extracted by mini-css-extract-plugin
export default {"ctaSection":"styles_ctaSection__ETogs","ctaBox":"styles_ctaBox__JK91y","ctaTitle":"styles_ctaTitle__2KD+S","ctaDesc":"styles_ctaDesc__c3fg4","btnPrimary":"styles_btnPrimary__x8siz"};